import packageInfo from '../../package.json';

export const environment = {
  production: true,
  apiUrl: '',
  gumUrl: '',
  version: packageInfo.version,
};
